import type { StationStatusData } from '../../../types/weatherData';

/**
 * The "Latest" values shown atop each weather station detail graph.
 *
 * These come from `latestReading.environmentalData` — the backend's
 * `ORDER BY timestamp DESC LIMIT 1` row — which is the single source of
 * truth for the most recent reading. They must NOT be read from the trend
 * series: that series is ordered newest-first, so its last element is the
 * oldest point in the 24-reading window (~yesterday). See bug #675.
 */
export interface LatestReadout {
    temperature: number | null;
    humidity: number | null;
    windSpeed: number | null;
}

export function getLatestReadout(status: StationStatusData): LatestReadout {
    const env = status.latestReading.environmentalData;
    return {
        temperature: env.temp,
        humidity: env.rh,
        windSpeed: env.wspd,
    };
}
